import React from "react";
import "./global.scss";
import "./style.scss";
import { Route, Routes } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "routes";
import { AuthMiddleware, PublicRoute } from "routes/route";

function App() {
  return (
    <React.Fragment>
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<PublicRoute>{route.element}</PublicRoute>}
            key={idx}
          />
        ))}
        {console.log(process.env.REACT_APP_ENV)}
        ENV:{process.env.REACT_APP_ENV}
        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<AuthMiddleware>{route.element}</AuthMiddleware>}
            key={idx}
          />
        ))}
      </Routes>
    </React.Fragment>
  );
}

export default App;
